import { memo, useContext } from 'react';
// import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';

import { DrawerContext } from '../drawer';
import MenuSection from './components/menuSection';
import { ClientStatusContext } from '../../../../../common/client-status';

import { menuConfig } from './config';
import { getUserMenu } from './utils';

// const useStyles = makeStyles(() => ({
//   navigation: {
//     overflowY: 'auto'
//   }
// }));

const Menu = () => {
  // const classes = useStyles();
  const { drawerState } = useContext(DrawerContext);
  const { checkIfUserHasPortalPrivilege } = useContext(ClientStatusContext);

  const userMenu = getUserMenu(menuConfig, checkIfUserHasPortalPrivilege);

  return (
    <Box>
      {userMenu.map((menuSectionProps, index) => (
        <MenuSection {...menuSectionProps} key={index} isShrinked={drawerState === 'shrinked'} />
      ))}
    </Box>
  );
};

export default memo(Menu);
